<template>
	<div style="width: 100%; overflow-y: auto; padding-right: 20px" :style="{ height: height + 'px' }">
		<div style="width: 100%">
			<grid-layout
				:layout.sync="layout"
				style="z-index: 1"
				:col-num="10"
				:row-height="60"
				:is-draggable="true"
				:is-resizable="false"
				:responsive="true"
				:vertical-compact="true"
				:use-css-transforms="true"
			>
				<!-- UTENTI -->
				<grid-item
					v-if="mySubscription"
					:i="layout[0].i"
					:x="layout[0].x"
					:y="layout[0].y"
					:w="layout[0].w"
					:h="layout[0].h"
				>
					<div class="card state md-elevation-4" style="background-color: #6fe3e1ff">
						<div style="padding: 10px">
							<div>
								<span style="font-size: 24px; font-weight: 900">{{ $t("users") }}</span>
							</div>
						</div>
						<div class="value">
							<span> {{ users.length }} / {{ MAX_USERS }}</span>
						</div>
					</div>
				</grid-item>
				<!-- PROGETTI -->
				<grid-item
					v-if="mySubscription"
					:i="layout[1].i"
					:x="layout[1].x"
					:y="layout[1].y"
					:w="layout[1].w"
					:h="layout[1].h"
				>
					<div class="card state md-elevation-4" style="background-color: #6bcfe2ff">
						<div style="padding: 10px">
							<span style="font-size: 24px; font-weight: 900">{{ $t("projects") }}</span>
						</div>
						<div class="value">
							<span>{{ projects }}</span>
						</div>
					</div>
				</grid-item>
				<!-- DOCUMENTI SALVATI -->
				<grid-item
					v-if="mySubscription"
					:i="layout[2].i"
					:x="layout[2].x"
					:y="layout[2].y"
					:w="layout[2].w"
					:h="layout[2].h"
				>
					<div class="card state md-elevation-4" style="background-color: #67bbe2ff">
						<div style="padding: 10px">
							<span style="font-size: 24px; font-weight: 900">{{ $t("saved-doc") }}</span>
						</div>
						<div class="value">
							<span>{{ saved_documents }}</span>
						</div>
					</div>
				</grid-item>

				<!-- BOZZE -->
				<grid-item
					v-if="mySubscription"
					:i="layout[3].i"
					:x="layout[3].x"
					:y="layout[3].y"
					:w="layout[3].w"
					:h="layout[3].h"
				>
					<div class="card state md-elevation-4" style="background-color: #63a7e3ff">
						<div style="padding: 10px">
							<span style="font-size: 24px; font-weight: 900">{{ $t("draft-doc") }}</span>
						</div>
						<div class="value">
							<span>{{ draft_documents }}</span>
						</div>
					</div>
				</grid-item>

				<!-- DOCUMENTI TOTALI DISPONIBILI -->
				<grid-item
					v-if="mySubscription"
					:i="layout[7].i"
					:x="layout[7].x"
					:y="layout[7].y"
					:w="layout[7].w"
					:h="layout[7].h"
				>
					<div class="card state md-elevation-4" style="background-color: #5e93e3ff">
						<div style="padding: 10px">
							<span style="font-size: 24px; font-weight: 900">{{
								$t("total-doc-that-you-can-access")
							}}</span>
						</div>
						<div class="value">
							<span>{{ this.numbers.docs }}</span>
						</div>
					</div>
				</grid-item>

				<!-- PROCEDURE TOTALI DISPONIBILI -->
				<grid-item
					v-if="mySubscription"
					:i="layout[8].i"
					:x="layout[8].x"
					:y="layout[8].y"
					:w="layout[8].w"
					:h="layout[8].h"
				>
					<div class="card state md-elevation-4" style="background-color: #5a7fe4ff">
						<div style="padding: 10px">
							<span style="font-size: 24px; font-weight: 900">{{
								$t("total-folder-that-you-can-access")
							}}</span>
						</div>
						<div class="value">
							<span>{{ this.numbers.folders }}</span>
						</div>
					</div>
				</grid-item>

				<!-- TOTALE DOCUMENTI -->
				<grid-item
					v-if="mySubscription"
					:i="layout[9].i"
					:x="layout[9].x"
					:y="layout[9].y"
					:w="layout[9].w"
					:h="layout[9].h"
				>
					<div class="card state md-elevation-4" style="background-color: #566be4ff">
						<div style="padding: 10px">
							<span style="font-size: 24px; font-weight: 900">{{ $t("total-doc") }}</span>
						</div>
						<div class="value">
							<span>{{ total_docs }}</span>
						</div>
					</div>
				</grid-item>

				<!-- TOTALE PROCEDURE -->
				<grid-item
					v-if="mySubscription"
					:i="layout[10].i"
					:x="layout[10].x"
					:y="layout[10].y"
					:w="layout[10].w"
					:h="layout[10].h"
				>
					<div class="card state md-elevation-4" style="background-color: #5257e5ff">
						<div style="padding: 10px">
							<span style="font-size: 24px; font-weight: 900">{{ $t("total-folder") }}</span>
						</div>
						<div class="value">
							<span>{{ total_folder }}</span>
						</div>
					</div>
				</grid-item>

				<!-- SCADENZA ABBONAMENTO -->
				<grid-item :i="layout[5].i" :x="layout[5].x" :y="layout[5].y" :w="layout[5].w" :h="layout[5].h">
					<div class="card" style="width: 100%; height: 100%">
						<div v-if="mySubscription">
							<div style="display: flex; flex-direction: column">
								<div style="width: 100%; display: flex; justify-content: center">
									{{ $t("subscription-expire") + ": " }}
								</div>
								<div style="width: 100%; display: flex; justify-content: center">
									{{ moment(mySubscription.valid_until).format("DD-MM-YYYY") }}
								</div>
								<div style="width: 100%; display: flex; justify-content: center">
									<div style="width: 100%; display: flex; margin-top: 5px">
										<div style="margin-left: auto; margin-right: auto; display: flex">
											<div>
												<div style="font-size: 34px; margin: 5px">
													<span>{{ duration.days }}</span>
												</div>
												<div class="label">
													<span>{{ $t("days") }}</span>
												</div>
											</div>
											<div>
												<div style="font-size: 34px; margin: 5px">
													<span>{{ duration.hours }}</span>
												</div>
												<div class="label">
													<span>{{ $t("hours") }}</span>
												</div>
											</div>
											<div>
												<div style="font-size: 34px; margin: 5px">
													<span>{{ duration.minutes }}</span>
												</div>
												<div class="label">
													<span>{{ $t("minutes") }}</span>
												</div>
											</div>
											<!-- <div>
												<div class="value">
													<span>{{ duration.seconds }}</span>
												</div>
												<div class="label">
													<span>{{ $t("secs") }}</span>
												</div>
											</div> -->
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-else style="height: 100%">
							<div
								style="
									display: flex;
									width: 100%;
									justify-content: space-around;
									align-items: center;
									height: 100%;
								"
							>
								<div>
									<md-icon class="md-size-2x" style="color: #f56c6c">warning</md-icon>
								</div>
								<div style="font-size: 1.2em">{{ $t("expired-subscription") }}</div>
							</div>
						</div>
					</div>
				</grid-item>

				<!-- STATO ABBONAMENTO -->
				<grid-item
					v-if="mySubscription"
					:i="layout[6].i"
					:x="layout[6].x"
					:y="layout[6].y"
					:w="layout[6].w"
					:h="layout[6].h"
				>
					<div class="card" style="width: 100%; height: 100%">
						<div style="display: flex">
							<div style="width: 100px; margin: auto">
								<div style="margin-top: -15px; text-align: center">
									{{ $t("subscription-status") }}
								</div>
								<apexchart
									type="radialBar"
									height="150"
									ref="charts"
									:options="chartOptions"
									:series="series"
								/>
							</div>
							<div></div>
						</div>
					</div>
				</grid-item>

				<!-- SCADENZA PASSWORD -->
				<grid-item
					v-if="pwd_exp_days < 11"
					:i="layout[4].i"
					:x="layout[4].x"
					:y="layout[4].y"
					:w="layout[4].w"
					:h="layout[4].h"
				>
					<div class="card state md-elevation-4" style="background-color: #ff4d4d">
						<div style="padding: 10px">
							<span style="font-size: 24px; font-weight: 900">{{ $t("expiring-pwd") }}</span>
							<p style="font-size: 20px; margin-top: 10px">
								{{
									$t("expiring-pwd-text")
										.replace("%NUMBER%", pwd_exp_days)
										.replace("%DAY%", pwd_exp_days == 1 ? "giorno" : "giorni")
								}}
							</p>
						</div>
					</div>
				</grid-item>
			</grid-layout>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import moment from "moment"
import { GridLayout, GridItem } from "vue-grid-layout"
import axios from "axios"

export default {
	components: {
		GridLayout,
		GridItem
	},
	name: "user-dashboard",
	data() {
		return {
			MAX_USERS: 5,
			users: [],
			projects: 0,
			saved_documents: 0,
			draft_documents: 0,
			numbers: {},
			total_docs: 0,
			total_folder: 0,
			pwd_exp_days: 100,
			height: window.innerHeight - 90,
			layout: [
				{ x: 0, y: 0, w: 2, h: 3, i: "0" }, //UTENTI
				{ x: 2, y: 0, w: 2, h: 3, i: "1" }, //PROGETTI
				{ x: 4, y: 0, w: 2, h: 3, i: "2" }, //DOCUMENTI SALVATI
				{ x: 6, y: 0, w: 2, h: 3, i: "3" }, //BOZZE

				{ x: 0, y: 3, w: 8, h: 3, i: "4" }, //SCADENZA PASSWORD
				{ x: 8, y: 0, w: 3, h: 3, i: "5" }, //SCADENZA ABBONAMENTO
				{ x: 8, y: 1, w: 3, h: 3, i: "6" }, //STATO ABBONAMENTO

				{ x: 0, y: 1, w: 2, h: 3, i: "7" }, //DOCUMENTI TOTALI DISPONIBILI
				{ x: 2, y: 1, w: 2, h: 3, i: "8" }, //PROCEDURE TOTALI DISPONIBILI
				{ x: 4, y: 1, w: 2, h: 3, i: "9" }, //TOTALE DOCUMENTI
				{ x: 6, y: 1, w: 2, h: 3, i: "10" } //TOTALE PROCEDURE
			],
			now: new Date(),

			series: [0],
			chartOptions: {
				chart: {
					height: 150,
					type: "radialBar"
				},
				plotOptions: {
					radialBar: {
						hollow: {
							size: "40%"
						},
						offsetY: -20,
						dataLabels: {
							name: { show: false },
							value: {
								offsetY: 5
							}
						}
					}
				},
				fill: {
					colors: ["#81c784"]
				},
				labels: [""]
			},

			tot: 44,
			draft: 2,
			completed: 10
		}
	},
	computed: {
		...mapGetters({
			mySubscription: "organization/active_subscription",
			pwd_exp: "user/pwd_exp"
		}),
		duration: function () {
			if (this.mySubscription == undefined) return {}
			var valid_until = moment(this.mySubscription.valid_until)
			var r = moment.duration(valid_until.diff(this.now))
			var secs = r.asSeconds()

			var days = parseInt(secs / 60 / 60 / 24)
			secs = secs - days * 60 * 60 * 24

			var hours = parseInt(secs / 60 / 60)
			secs = secs - hours * 60 * 60

			var minutes = parseInt(secs / 60)
			secs = secs - minutes * 60

			var seconds = parseInt(secs)

			days = days < 10 ? "0" + days : days
			hours = hours < 10 ? "0" + hours : hours
			minutes = minutes < 10 ? "0" + minutes : minutes
			seconds = seconds < 10 ? "0" + seconds : seconds
			return { days, hours, minutes, seconds }
		},
		usage: function () {
			var start = this.mySubscription.valid_from
			var end = this.mySubscription.valid_until
			var now = Date.now()

			var myDatestart = start.split("T")[0]
			myDatestart = myDatestart.split("-")
			var newDatestart = new Date(myDatestart[0], myDatestart[1] - 1, myDatestart[2])

			var myDateend = end.split("T")[0]
			myDateend = myDateend.split("-")
			var newDateend = new Date(myDateend[0], myDateend[1] - 1, myDateend[2])

			return (((now - newDatestart.getTime()) * 100) / (newDateend.getTime() - newDatestart.getTime())).toFixed(2)
		}
	},
	watch: {
		mySubscription: function (e) {
			if (e) {
				this.series = [this.usage]
				if (this.$refs.charts) {
					this.$refs.charts.updateSeries(this.series, true, true, true)
				}

				this.getProjects()
			}
		},
		pwd_exp: function () {
			this.pwd_exp_days = 3
		}
	},
	async mounted() {
		if (this.pwd_exp) {
			var valid_until = moment(this.pwd_exp)
			var r = moment.duration(valid_until.diff(this.now))
			this.pwd_exp_days = Math.ceil(r.asDays())
		}

		this.getOrgSubscriptions()
		if (this.mySubscription) {
			this.users = await this.doUsers(this.mySubscription.organization_id)
			this.users = this.users.filter(x => x.deleted_at == undefined)
			this.getProjects()
		}
		axios(`${process.env.VUE_APP_API_URL}/api/documents/`, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("JWT")}`
			}
		})
			.then(({ data }) => {
				data.forEach(ee => {
					if (ee.status === "draft") {
						this.draft_documents++
					} else {
						this.saved_documents++
					}
				})
			})
			.catch(() => {})

		axios(`${process.env.VUE_APP_API_URL}/api/documents/count`, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("JWT")}`
			}
		})
			.then(({ data }) => {
				this.total_docs = data
			})
			.catch(() => {})

		this.getHome()

		setInterval(() => {
			this.now = new Date()
		}, 1000)
	},

	methods: {
		...mapActions({
			doUsers: "organization/doUsers",
			getOrgSubscriptions: "organization/organizationSubscription"
		}),
		getProjects() {
			const payload = {
				organization_id: this.mySubscription.organization_id
			}

			axios
				.post(process.env.VUE_APP_API_URL + "/api/projects/get", payload, {
					headers: {
						Authorization: `Bearer ${localStorage.getItem("JWT")}`
					}
				})
				.then(({ data }) => {
					this.projects = data.total
				})
				.catch(() => {})
		},
		getHome() {
			this.numbers = { docs: 0, folders: 0 }
			const payload = {
				search: "",
				pagination: {
					offset: 0,
					size: 4
				}
			}
			axios
				.post(`${process.env.VUE_APP_API_URL}/api/flowchart/getBySubscription`, payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					this.numbers.docs = res.data.total
					this.total_docs = res.data.unscoped_total
				})
			axios
				.post(`${process.env.VUE_APP_API_URL}/api/folders/getBySubscription`, payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(res => {
					this.numbers.folders = res.data.total
					this.total_folder = res.data.unscoped_total
				})
		}
	}
}
</script>
<style scoped lang="scss">
.card {
	background-color: white;
	padding: 20px;
	border-radius: 25px;
	margin: 5px;
	width: 100%;
	height: 100%;
}

.state {
	color: white;

	.value {
		display: flex;

		span {
			margin-left: auto;
			margin-right: 0;
			font-size: 38px;
		}
	}
}

span,
strong {
	font-family: "Montserrat", sans-serif;
	margin-right: 5px;
}

.value {
	font-size: 34px;
	position: absolute;
	bottom: 15px;
	right: 15px;
}

.label {
	font-size: 14px;
	margin: 5px;
	display: flex;

	span {
		margin-left: auto;
		margin-right: auto;
	}
}

.vue-grid-layout {
	background: #eee;
}

.vue-grid-item .resizing {
	opacity: 0.9;
}

.vue-grid-item .static {
	background: #cce;
}

.vue-grid-item .text {
	font-size: 24px;
	text-align: center;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	height: 100%;
	width: 100%;
}

.vue-grid-item .no-drag {
	height: 100%;
	width: 100%;
}

.vue-grid-item .minMax {
	font-size: 12px;
}

.vue-grid-item .add {
	cursor: pointer;
}

.vue-draggable-handle {
	position: absolute;
	width: 20px;
	height: 20px;
	top: 0;
	left: 0;

	background-position: bottom right;
	padding: 0 8px 8px 0;
	background-repeat: no-repeat;
	background-origin: content-box;
	box-sizing: border-box;
	cursor: pointer;
}
</style>
